import { useState } from 'react';
import { useSpring, animated, Spring } from 'react-spring'
import VisibilitySensor from "react-visibility-sensor";


function MainRow() {

	const [isInView, setIsInView] = useState(true);
	const [isInView1, setIsInView1] = useState(false);

	const fadeIn = useSpring({
		from: { opacity: isInView ? 0. : 1 },
		to: { opacity: isInView ? 1 : 0 },
		delay: isInView ? 100 : 0,
		config: { duration: isInView ? 2000 : 1000 }
	})


	const fadeIn1 = useSpring({
		transform: "translate(0px, -10px)",
		from: { opacity: isInView1 ? 0 : 1 },
		to: { opacity: isInView1 ? 1 : 0, transform: isInView1 ? "translate(0, 0)" : "translate(0, 0px)" },
		delay: isInView1 ? 200 : 0,
		config: { duration: isInView1 ? 3000 : 0 }
	})





	const onVisibilityChange = isInView => isInView ? setIsInView(isInView) : null;
	const onVisibilityChange1 = isInView1 => setIsInView1(isInView1);



	return (
		<div className="row " >
			<div
				className="col-sm-12 justify-content-center align-items-center"
				style={{
					backgroundImage: "url('')",
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					minHeight: "70vh",
					backgroundColor: "",
					color: "#000",
					marginTop: "50px"
				}}
			>
				<div className="row ">
					<div className="col-2"></div>
					<div className="col-sm-12 d-flex justify-content-center align-items-center text-center">



						<VisibilitySensor onChange={onVisibilityChange}>
							{({ isVisible }) => (
								<animated.div style={fadeIn}>
									<h1 className="text-white custom1" style={{ fontSize: "60px" }}>
										{window.locale.translate('The Alcohol Book')}
									</h1>
								</animated.div>
							)}
						</VisibilitySensor>

					</div>


					<div className="col-2"></div>
					<div className="col-12 d-flex justify-content-center align-items-center mt-4">

						<VisibilitySensor onChange={onVisibilityChange1} partialVisibility={true}>
							{({ isVisible }) => (
								<animated.div style={fadeIn1}>
									<a href="https://app.edistillery.com.au/register" target="_blank">
										<button className="btn btn-lg mb-3 register-button">
											{window.locale.translate('Get 95% Off Now')}
										</button>
									</a>
								</animated.div>
							)}
						</VisibilitySensor>

					</div>

					{/* 
					<div className="col-sm-12">
						<div className="row mt-4">
							<div className="col-sm-12 pl-4 pr-4 d-flex text-center justify-content-center align-items-center mt-3">


								<VisibilitySensor onChange={onVisibilityChange}>
									{({ isVisible }) => (
										<animated.div style={fadeIn}>
											<h3 className="custom2 text-white" style={{ fontSize: "22px" }}>
												{window.locale.translate('A COMPREHENSIVE TOOL FOR WORKING WITH ALCOHOL AND ITS RECORD KEEPING')}
											</h3>
										</animated.div>
									)}
								</VisibilitySensor>

							</div>
						</div>
					</div>

					<div className="col-sm-12">
						<div className="row ">
							<div className="col-sm-2"></div>
							<div className="col-sm-8 d-flex text-center justify-content-center align-items-center ">


								<VisibilitySensor onChange={onVisibilityChange}>
									{({ isVisible }) => (
										<animated.div style={fadeIn}>
											<h3 className="custom3 text-white mb-5 mt-3 pr-2 pl-2" style={{ fontSize: "22px" }}>
												{window.locale.translate('Build your warehouse, access from anywhere, follow the ATO guidelies')}
											</h3>
										</animated.div>
									)}
								</VisibilitySensor>

							</div>
							<div className="col-sm-2"></div>
						</div>
					</div>

 */}

				</div>
			</div>
		</div>
	);
}

export default MainRow;
